import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserService } from '../services/UserService';
import { User } from '@socrates/common';

@Injectable()
export class AuthenticatedResolver implements Resolve<User> {
	constructor(private userService: UserService, private router: Router) {
	}

	async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<User> {
		try {
			return await this.userService.checkSession();
		} catch {
			this.userService.detouredRoute = state.url;
			this.router.navigate(['/login']);
			return null;
		}
	}
}

export const AUTHENTICATED_RESOLVER_PROVIDERS = [
	AuthenticatedResolver
];
